<div class="contracts-not-selected-root">
  <img class="empty-chat" alt="empty" src="../../../../assets/images/empty-list.png"/>

  <ng-content select="[text]"></ng-content>
  <ng-content select="[caption]"></ng-content>
  <ng-content select="[button]"></ng-content>
</div>
